import React from 'react'

import { View, ToolTip } from 'lib/components'
import IProduct from 'domains/products/models/IProduct'
import useModalState from 'lib/hooks/useModalState'
import ProductPPListModal from 'domains/products/modals/ProductPPListModal'
import PreferredPartnerBadge from 'domains/products/components/PreferredPartnerBadge'
import { utils } from '@ims/1edtech-frontend-common'

interface IProps extends IProduct {
  size?: number
}

export default function DistrictProductCatalogPPCell(props: IProps) {
  const [isModalOpen, openModal, closeModal] = useModalState()

  if (!utils.hasValue(props.preferrers)) {
    return null
  }

  return (
    <View flexible="column-center" hover="clickable">
      <View onClick={openModal} data-test={`pp-icon-${props.id}`}>
        <ToolTip
          id={`pp-icon-tip-${props.id}`}
          dataTest={`pp-icon-tip-${props.id}`}
          tip="Available via Preferred Partner(s)"
          delay={250}
        >
          <PreferredPartnerBadge size={props.size} />
        </ToolTip>
      </View>

      <ProductPPListModal
        isOpen={isModalOpen}
        closeModal={closeModal}
        product={props}
      />
    </View>
  )
}
